import { useState } from 'react';
import { Typography, Box, Link, Stack } from '@mui/material';
import { storage } from '@goldblack/client-storage';
import { OpenSourceDialog } from './opensource-dialog';
import { LegalDialog } from '@goldblack/client-comps';
import { url as urlUtils } from '@goldblack/client-utils';

function Footer() {
    const privacyUrl = urlUtils.buildUrl(import.meta.env.VITE_R2_BASE_URL, import.meta.env.VITE_PRIVACY_URL);
    const termsUrl = urlUtils.buildUrl(import.meta.env.VITE_R2_BASE_URL, import.meta.env.VITE_TERMS_URL);

    const [ossOpen, setOssOpen] = useState(false);
    const [privacyOpen, setPrivacyOpen] = useState(false);
    const [termsOpen, setTermsOpen] = useState(false);

    // 1. 공통 경로 변경 핸들러
    const navigateTo = (path) => {
        storage.transience.setState('path.gateway', path);
    };

    const onClickFooter = (path) => {
        if (path === 'opensource') {
            setOssOpen(true);
        } else if (path === 'privacy') {
            setPrivacyOpen(true);
        } else if (path === 'terms') {
            setTermsOpen(true);
        } else if (path.startsWith('http')) {
            window.open(path, '_blank', 'noopener,noreferrer');
        } else {
            navigateTo(path);
        }
    };

    // 2. 메뉴 구성 데이터
    const menuItems = [
        { label: 'Privacy', path: 'privacy' },
        { label: 'Terms', path: 'terms' },
        { label: 'Open Source', path: 'opensource' },
    ];

    return (
        <Box component='footer' sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* 상단 링크 바 */}
            <Stack direction='row' spacing={2} justifyContent='center' flexWrap='wrap'>
                {menuItems.map((item) => (
                    <Link
                        key={item.path}
                        onClick={() => onClickFooter(item.path)}
                        variant='body2'
                        component='button'
                        sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}>
                        {item.label}
                    </Link>
                ))}
            </Stack>

            {/* 하단 카피라이트 */}
            <Typography align='center' variant='caption' color='text.secondary' sx={{ mt: 1 }}>
                © 2026 {import.meta.env.VITE_SERVICE_TITLE} ·{' '}
                <Link
                    href='https://goldblack.io'
                    target='_blank'
                    rel='noopener noreferrer'
                    variant='caption'
                    sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}>
                    {import.meta.env.VITE_PLATFORM_TITLE}
                </Link>
            </Typography>

            <OpenSourceDialog open={ossOpen} onClose={() => setOssOpen(false)} />
            <LegalDialog
                readOnly
                open={privacyOpen}
                title='Privacy Policy'
                type='privacy'
                url={privacyUrl}
                onClose={() => setPrivacyOpen(false)}
            />
            <LegalDialog
                readOnly
                open={termsOpen}
                title='Terms of Use'
                type='terms'
                url={termsUrl}
                onClose={() => setTermsOpen(false)}
            />
        </Box>
    );
}

export { Footer };
